// Password-recovery flow detection.
//
// A reset-password email routes the user through Supabase's
// /auth/v1/verify endpoint, which mints a one-time recovery session and
// redirects back to the app with `type=recovery` in the URL fragment.
// The reset form only mounts at the /reset-password route — so the app
// needs to know "this page load is a recovery flow" no matter where the
// email link actually dropped the user. These helpers are that signal.

// True when the address bar currently carries Supabase's recovery
// marker. Checked both at module-load (the snapshot below) and live
// inside RecoveryRedirect's effect.
export function urlHasRecoveryToken(): boolean {
  if (typeof window === 'undefined') return false;
  return (window.location.hash + window.location.search).includes('type=recovery');
}

// Snapshot taken at module-eval time — this runs during the app's
// synchronous import phase, before Supabase's `detectSessionInUrl`
// parsing (an async microtask) consumes the recovery token and strips
// it from the address bar. Reading the URL later races that cleanup and
// usually loses, so we capture it here once and trust it.
export const arrivedViaRecovery = urlHasRecoveryToken();
